import { db } from '../client/index';
import { collection, getDocs, doc, getDoc, addDoc, updateDoc, deleteDoc } from 'firebase/firestore/lite';

const policiesCollection = collection(db, 'policies');

export const getPolicies = async () => {
  try {
    const policiesSnapshot = (await getDocs(policiesCollection)).docs;
    const policiesItems = policiesSnapshot.map(policy => policy.data());
    return policiesItems;
  } catch (err) {
    return err;
  }
}

export const getPolicy = async (id) => {
  try {
    const policySnapshot = doc(db, 'policies', id);
    const policyItem = await getDoc(policySnapshot);
    return policyItem.exists() ? policyItem.data() : null;
  } catch (err) {
    return err;
  }
}

export const createPolicy = async (policy) => {
  try {
    const { id } = await addDoc(policiesCollection, policy);
    const policyAdded = { id, ...policy };
    return policyAdded;
  } catch (err) {
    return err;
  }
}

export const updatePolicy = async (id, policy) => {
  try {
    const policyRef = doc(db, 'policies', id);
    await updateDoc(policyRef, policy);
    return { id, ...policy };
  } catch (err) {
    return err;
  }
}

export const deletePolicy = async (id) => {
  try {
    const policyRef = doc(db, 'policies', id);
    await deleteDoc(policyRef);
    return id
  } catch (err) {
    return err;
  }
}